export default __webpack_public_path__ + "static/media/Landing.c61f653a.jpg";